import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { API } from "../../data/site";

export const BlogList = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  if (posts === null) {
    return <p className="mt-20 text-sm text-graphite/50" data-testid="blog-loading">Зареждане...</p>;
  }

  if (posts.length === 0) {
    return (
      <Reveal delay={0.15}>
        <div className="mt-20 border border-hairline bg-sanddeep/40 p-14 text-center lg:p-20" data-testid="blog-empty-state">
          <p className="font-serif text-3xl font-light text-graphite/70">Скоро тук ще се появят първите статии.</p>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-graphite/55">
            Работя по първите рубрики. А междувременно – заповядайте на безплатна консултация, винаги е по-лично на живо.
          </p>
          <Link
            to="/kontakti"
            data-testid="blog-empty-cta"
            className="mt-8 inline-block border border-burgundy bg-transparent px-10 py-4 text-[12px] uppercase tracking-[0.2em] text-burgundy transition-colors duration-[400ms] hover:bg-burgundy hover:text-sand"
          >
            Запазете безплатна консултация
          </Link>
        </div>
      </Reveal>
    );
  }

  return (
    <div className="mt-20">
      {posts.map((p, i) => (
        <Reveal key={p.id} delay={i * 0.06} data-testid={`blog-item-${p.slug}`}>
          <Link to={`/blog/${p.slug}`} className="group grid gap-4 border-t border-hairline py-12 md:grid-cols-12 md:items-baseline">
            <p className="text-xs uppercase tracking-[0.25em] text-graphite/45 md:col-span-2">
              {new Date(p.created_at).toLocaleDateString("bg-BG", { day: "numeric", month: "long", year: "numeric" })}
            </p>
            <h2 className="font-serif text-3xl font-light transition-colors duration-500 group-hover:text-burgundy md:col-span-5">
              {p.title}
            </h2>
            <p className="max-w-md text-sm leading-relaxed text-graphite/60 md:col-span-4">{p.excerpt}</p>
            <ArrowRight size={18} strokeWidth={1.5} className="hidden text-burgundy transition-transform duration-500 group-hover:translate-x-1.5 md:col-span-1 md:block md:justify-self-end" />
          </Link>
        </Reveal>
      ))}
    </div>
  );
};
